import React, {Component} from 'react';
import axios from 'axios';
import config from "../config";
import withError from "../withError";
import i18n from "../i18n";
import StepView from "../views/StepView";

class StepController extends Component {
  constructor(props) {
    super(props);

  }

  render() {
    return <StepView {...this.props}
                     resultDefaultImage={config.styleguide + '/assets/img/images/results-card.png'}/>;
  }
}

export default withError(StepController);
